import { Conditions } from 'modules/cohort-browser/enums'

export const conditionsWithNoValues: Conditions[] = [
  Conditions.IsBlank,
  Conditions.IsNotBlank,
  Conditions.IsNull,
  Conditions.IsNotNull
]

export const conditionsWithExactlyTwoValues: Conditions[] = [Conditions.Between, Conditions.NotBetween]

export const conditionsWithCSV: Conditions[] = [
  Conditions.ContainsOneOf,
  Conditions.EqualsOneOf,
  Conditions.NotContainsAnyOf,
  Conditions.NotEqualsAnyOf
]
